import React from "react";
import { dispatch } from '@rematch/core';
import { Icon, Popup, Button, Divider, Modal } from "semantic-ui-react";
import { toastr } from 'react-redux-toastr';
import EllipsisTooltip from "../../common/EllipsisTooltip";
import { singleLineText, urlValidation } from '../../common/RegexValidation';
import { Form } from 'formsy-semantic-ui-react';
import objectId from '../../../helpers/objectId';
var moment = require('moment');
class AttachmentDisplay extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            linkOpen: false
        }
    }

    isAuthor = () => {
        if (this.props.isAuthor) {
            return true;
        }
        else {
            return false;
        }
    }

    isWorkspaceOwner = () => {
        if (this.props.isWorkspaceOwner) {
            return true;
        }
        else {
            return false;
        }
    }

    isContributor = () => {
        if (this.props.isContributor) {
            return true;
        }
        else {
            return false;
        }
    }

    downloadAttachment = (attachment) => {
        if (this.props.playbookStatus && this.props.playbookStatus === 4 && this.props.isPublic) {
            attachment.isPublic = true;
        }
        attachment.accountId = this.props.accountId;
        dispatch.app.downloadAttachment(attachment);
    }

    viewLink = (e, attachment) => {
        if (e) {
            e.stopPropagation()
        }
        let redirectUrl = attachment.documentUrl.indexOf('://') === -1 ? 'http://' + attachment.documentUrl : attachment.documentUrl;
        window.open(redirectUrl, '_blank');
    }

    deleteAttachment = (attachment) => {
        attachment.resourceId = this.props.resourceId;
        attachment.entityName = this.props.entityName;

        let message = <div className="confirmMessage">
            <h3>Delete Attachment</h3>
            <label>{attachment.documentName}</label>
            <p>Are you sure to delete this Attachment?</p>
            <span >This action is not reversible.</span>
        </div>
        toastr.confirm(message, {
            onOk: () => {
                dispatch.app.deleteAttachment(attachment);
            }
        });
    }

    editLink(attachment) {
        this.setState({
            linkOpen: true,
            selectedAttachment: attachment
        })
    }
    addLink = async () => {

        let document = {};
        document.documentName = this.state.selectedAttachment.documentName;
        document.documentId = objectId();
        document.documentUrl = this.state.selectedAttachment.documentUrl;
        document.uploadedBy = this.props.user && this.props.user._id;
        document.uploadedAt = moment();

        let attachments = this.props.selectedData && this.props.selectedData.attachments ? this.props.selectedData.attachments : [];
        var foundIndex = attachments.findIndex(
            (x) => x.uploadedAt == this.state.selectedAttachment.uploadedAt
        );
        attachments.slice(0, foundIndex);
        attachments[foundIndex] = document;

        let attachmentPayload = {}

        if (this.props.to === 'initiativeActivity') {
            attachmentPayload.initiativeId = this.props.selectedData.initiativeId._id ? this.props.selectedData.initiativeId._id : this.props.selectedData.initiativeId
            attachmentPayload._id = this.props.selectedData._id;
            attachmentPayload.attachments = attachments
            await dispatch.initiatives.updateInitiativeActivities(attachmentPayload);
        } else if (this.props.to === 'initiative') {
            attachmentPayload.id = this.props.selectedData._id;
            attachmentPayload.attachments = attachments
            await dispatch.initiatives.updateInitiative(attachmentPayload);
        } else if (this.props.to === "playbook") {
            attachmentPayload._id = this.props.selectedData._id;
            attachmentPayload.name = this.props.selectedData.name;
            attachmentPayload.data = {
                attachments: attachments
            }
            await dispatch.lifeCycle.updatePlaybook(attachmentPayload);
        } else if (this.props.to === "playbookActivity") {
            attachmentPayload._id = this.props.selectedData._id;
            attachmentPayload.name = this.props.selectedData.name;
            attachmentPayload.data = {
                attachments: attachments
            }
            await dispatch.lifeCycle.updateAttachnmentInActivity(attachmentPayload);
        }

        this.close()
    }

    close = () => {
        this.setState({
            linkOpen: false,
            selectedAttachment: {}
        })
    }

    getIcon = () => {
        let extension = this.props.document.documentName && this.props.document.documentName.split('.').pop().toUpperCase()
        const documentTypes = ['PDF', 'DOC', 'DOCX', 'PPT', 'PPTX', 'XLS', 'XLSX', 'EPUB', 'ODT', 'ODP', 'ODS', 'TXT', 'RTF'];
        const imageTypes = ['BMP', 'PNG', 'JPG', 'JPEG', 'GIF', 'SVG', 'TIFF', 'EPS'];
        const audioTypes = ['WAV', 'MP3', 'WMA', 'FLAC', 'ALAC', 'PCM', 'AIFF', 'ACC', 'OGG'];
        const videoTypes = ['MPG', 'MPEG', 'MOV', 'MP4', 'AVI', 'WMV', 'FLV', 'SWF', 'WEBM', 'MPE', 'MPV', 'MP2', 'OGG', 'mp4', 'M4V', 'QT'];
        const zipTypes = ['ZIP', 'CAB', 'BIN', 'JAR', 'TAR', 'WAR', 'RAR', '7Z', 'GZ'];

        if (documentTypes.includes(extension)) {
            return 'file alternate'
        }
        if (imageTypes.includes(extension)) {
            return 'image'
        }
        if (audioTypes.includes(extension)) {
            return 'microphone'
        }
        if (videoTypes.includes(extension)) {
            return 'video'
        }
        if (zipTypes.includes(extension)) {
            return 'file archive'
        }
        return 'file';
    }

    render() {
        const errorLabel = <div className="customErrorLabel" />;

        let sameUser = this.props.user && this.props.document && this.props.document.uploadedBy && this.props.document.uploadedBy._id && this.props.user._id.toString() == this.props.document.uploadedBy._id.toString()
        let showDeleteicon = sameUser;
        if (sameUser) {
            if (this.props.document && this.props.document.inherited) {
                showDeleteicon = showDeleteicon || (this.props.document && this.props.document.inherited)
            }
        }
        if (this.props.selectedOrganization && (this.props.selectedOrganization.role == "workspaceOwner") ) {
            showDeleteicon = true;
        }
        if (this.props.selectedPlaybook && this.props.selectedPlaybook.participants && this.props.selectedPlaybook.participants.length > 0) {
            let participants = this.props.selectedPlaybook.participants;
            for (let participant of participants) {
                if ((this.props.user._id.toString() == participant.accountUserId.toString()) && (participant.role == "author" || participant.role == "contributor")) {
                    showDeleteicon = true;
                }
            }
        }
        if (this.props.selectedInitiative && this.props.selectedInitiative.createdBy) {
            if (this.props.user._id.toString() == this.props.selectedInitiative.createdBy.toString()) {
                showDeleteicon = true;
            }
        }
        if (this.props.initiativeStatus === 3 || this.props.initiativeStatus === 5 || (this.props.selectedPlaybook && this.props.selectedPlaybook.status && this.props.selectedPlaybook.status ===5) ) {
            showDeleteicon = false;
        }
        if (this.props.playbookStatus && (this.props.playbookStatus == 1 || this.props.playbookStatus == 2)) {
            showDeleteicon = false
        }
        // Old Condition
        // (this.props.user && this.props.document && this.props.document.uploadedBy && this.props.document.uploadedBy._id && this.props.user._id.toString() !== this.props.document.uploadedBy._id.toString())
        //             || (this.props.initiativeStatus === 2 || this.props.initiativeStatus === 3)
        //             || this.props.document.inherited
        //             || (this.props.playbookStatus && this.props.playbookStatus !== 0)

        // let docInherited = (this.props.document && this.props.document.inherited) ? this.props.document.inherited : false;
        // let pbStatus = !this.props.playbookStatus ? false : (this.props.playbookStatus && this.props.playbookStatus !== 0) ? false : true;
        // let showDeleteicon = (sameUser && (this.props.initiativeStatus === 2))
        //     || this.props.initiativeStatus === 5
        //     || docInherited
        //     || pbStatus

        return (
            <div className="float-left w_100 display-block">
                <div style={{ display: "inline-block", float: "left", width: "calc(100% - 95px" }}>
                    <EllipsisTooltip
                        name={this.props.document.documentName}
                        style={{ float: "left", width: "100%", lineHeight: "18px", fontFamily: 'montserrat-semibold', }}
                    />
                    {this.props.document.documentUrl ? 
                         <EllipsisTooltip
                            name={this.props.document.documentUrl}
                            style={{
                                float: "left", width: "100%", lineHeight: "18px", color: "gray",
                                fontSize: "11px",
                                margin: "-3px 0 0 0"
                            }}
                        />:null}
                </div>

                <div style={{ display: "inline-block", float: "right" }}>



                    {
                        showDeleteicon && this.props.document.documentUrl ?
                            <div className="float-left display-block pad_5">
                                <Popup className="popupStyled" inverted trigger={
                                    <span onMouseEnter={() => dispatch.app.setHelpContext("Edit Attachment")}>
                                        <Icon
                                            name="pencil"
                                            onClick={() => { this.editLink(this.props.document) }}
                                            className="float-right clr-yellow f_14 cursor-pointer"
                                            style={{ width: "18px" }}
                                        />
                                    </span>
                                }
                                    content='Edit'
                                />

                            </div> : null
                    }



                    {(this.props.document.documentUrl ? null :
                        !this.props.status || this.props.status === 0 ||
                        (this.props.status === 4 && (this.isAuthor() || this.isContributor() || this.isWorkspaceOwner()) ) )&&
                        <div className="float-left display-block pad_5">
                            <Popup className="popupStyled" inverted trigger={
                                <span onMouseEnter={() => dispatch.app.setHelpContext("Download Attachment")}>
                                    <Icon
                                        name={this.getIcon()}
                                        onClick={() => { this.downloadAttachment(this.props.document) }}
                                        className="float-right clr-blue f_14 cursor-pointer"
                                        style={{ width: "18px" }}
                                    />
                                </span>
                            }
                                content='Download'
                            />
                        </div>
                    }

                    {this.props.document.documentUrl ?
                        <div className="float-left display-block pad_5">
                            <Popup className="popupStyled" inverted trigger={
                                <span onMouseEnter={() => dispatch.app.setHelpContext("View Attachment")}>
                                    <Icon
                                        name="eye"
                                        onClick={(e) => { this.viewLink(e, this.props.document) }}
                                        className="float-right clr-blue f_14 cursor-pointer"
                                        style={{ width: "18px" }}
                                    />
                                </span>
                            }
                                content='View'
                            />
                        </div> : null
                    }

                    {
                        showDeleteicon ?
                            <div className="float-left display-block pad_5">
                                <Popup className="popupStyled" inverted trigger={
                                    <span onMouseEnter={() => dispatch.app.setHelpContext("Delete Attachment")}>
                                        <Icon
                                            name="trash"
                                            onClick={() => { this.deleteAttachment(this.props.document) }}
                                            className="float-right clr-orange f_14 cursor-pointer"
                                            style={{ width: "18px" }}
                                        />
                                    </span>
                                }
                                    content='Delete'
                                />

                            </div> : null
                    }
                </div>

                {this.state.linkOpen && this.state.selectedAttachment ?
                    <Modal
                        className="basicModal"
                        open={this.state.linkOpen}
                        size='mini'
                        onClose={this.close}
                        closeOnEscape={true}
                        closeOnDimmerClick={false}
                        closeIcon
                    >
                        <Modal.Header>Add File</Modal.Header>
                        <Divider style={{ margin: "10px 0 0px" }} />
                        <Modal.Content scrolling>
                            <Form noValidate
                                ref={ref => this.form = ref}
                                id="AddLink"
                                onValid={(e) => this.setState({ validForm: true })}
                                onInvalid={(e) => this.setState({ validForm: false })}
                            >
                                <Form.Input
                                    required
                                    name="Add Link Name"
                                    id="Add Link Name"
                                    label="Add Link Name"
                                    value={this.state.selectedAttachment.documentName}
                                    placeholder="Add Link Name"
                                    validations={{ matchRegexp: singleLineText }}
                                    errorLabel={errorLabel}
                                    validationErrors={{
                                        matchRegexp: 'Max limit is 128. No space allowed in starting.',
                                        isDefaultRequiredValue: `Link Name is required`,
                                    }}
                                    onChange={(e) => {

                                        this.setState({ selectedAttachment: { ...this.state.selectedAttachment, documentName: e.target.value.trim() } })

                                    }}
                                    instantValidation={true}
                                    autoFocus={true}
                                />

                                <Form.Input
                                    required
                                    name="Add Url"
                                    id="Add Url"
                                    label="Add Url"
                                    value={this.state.selectedAttachment.documentUrl}
                                    placeholder="Add Url"
                                    validations={{ matchRegexp: urlValidation }}
                                    errorLabel={errorLabel}
                                    validationErrors={{
                                        matchRegexp: 'Enter valid URL',
                                        isDefaultRequiredValue: `Url is required`,
                                    }}
                                    onChange={(e) => {

                                        this.setState({ selectedAttachment: { ...this.state.selectedAttachment, documentUrl: e.target.value.trim() } })
                                    }}
                                    instantValidation={true}
                                />
                            </Form>
                        </Modal.Content>
                        <Modal.Actions className="actionInFormcy border-none pad_0" style={{ "text-align": "right", margin: "0px 0px 15px -15px" }}>
                            <Button disabled={!this.state.validForm} content='Update Link' className="button-submit float-right" type="button" onClick={this.addLink} />
                            <Button content="Cancel" className="button-cancel" type="button" onClick={this.close} />
                        </Modal.Actions>
                    </Modal> : null}

            </div>
        );
    }
}
export default AttachmentDisplay;
